module.exports = __webpack_public_path__ + "img/alert.ffd4d8b9.jpg";